import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { Button } from '@/components/ui/button';
import Text from '@/components/ui/text';
import Title from '@/components/ui/title';
import { assets } from '@/lib/assets';
import PageRoutes from '@/lib/routing/PageRoutes';
import { stopSound } from '@/lib/utils/playSound';

export default function PageOutro() {
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      stopSound(assets.sounds.outroMusic, 1000, true);
    };
  }, []);

  return (
    <div className="flex flex-col justify-center px-10 pb-20 pt-10 text-center md:px-20">
      <img
        src="content/images/logo.png"
        alt="logo"
        className="max-h-40 object-contain pb-6"
      />
      <Title i18nKey="outro.title" className="pb-12 pt-10 text-4xl" />
      <Text i18nKey="outro.description" />

      <a
        href={t('outro.moreInfo.link')}
        target="_blank"
        rel="noopener noreferrer"
        className="pt-4 font-bold text-secondary underline"
      >
        {t('outro.moreInfo')}
      </a>

      <div className="flex grow justify-center">
        <NavLink to={PageRoutes.intro.path}>
          <Button variant="secondary" className="mt-10 w-60">
            {t('outro.button.continue')}
          </Button>
        </NavLink>
      </div>
    </div>
  );
}
